<template>
    <div>
        <div class="main-cnt ex-has-btn-btm">
            <div class="error-message" v-if="errorMessage">
                <div class="d-flex">
                    <i class="icon-warning mr-2"></i>
                    <div class="errror-txt">
                        <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                        <p class="fs-14 text-red font600">{{ errorMessage }}</p>
                    </div>
                </div>
            </div>
            <component
                v-bind:is="component"
                v-if="voucher.voucher_type_id"
                :voucherParams="voucherParams"
                :modeEdit="true"
                :setErrorMessage="setErrorMessage"
                @voucherSuccess="voucherSuccess"
                @update:actionHandler="$emit('update:actionHandler', $event)"
            ></component>
        </div>
    </div>
</template>

<script>
import VoucherService from "@/services/module/voucher.service";
import StorageService from "@/services/common/storage.service";
import { AuthService } from "@/services/common/auth.service";
import Utils from "@/helpers/utils";
import { Constants } from "@/helpers/constants";

export default {
    components: {},
    name: "SpEditVoucher",
    data () {
        return {
            voucher: {},
            voucherId: "",
            errorMessage: "",
            voucherParams: {},
            screenType: "",
        };
    },
    computed: {
        component: {
            get: function () {
                if (this.voucher.voucher_type_id) {
                    let templateId = Utils.getTemplateId(
                        this.voucher.voucher_type_id
                    );
                    if (!Utils.isEmptyStr(templateId)) {
                        this.voucherParams = {};
                        this.voucherParams.id = this.voucher.id;
                        this.voucherParams.voucherNumber = this.voucher.voucher_number;
                        this.voucherParams.tourNumber = this.voucher.tour_number;
                        this.voucherParams.travelGroupName = this.voucher.travel_group_name;
                        this.voucherParams.cashId = this.voucher.cash_id;
                        this.voucherParams.docId = this.voucher.doc_id;
                        this.voucherParams.type = this.voucher.type;
                        this.voucherParams.voucherTypeId = this.voucher.voucher_type_id;
                        this.voucherParams.voucherTypeName = this.voucher.voucher_type_name;
                        this.voucherParams.transactionDate = new Date(
                            this.voucher.transaction_date
                        );
                        this.voucherParams.accountName = this.voucher.account_name;
                        this.voucherParams.exchangeRate = this.voucher.exchange_rate;
                        this.voucherParams.city = this.voucher.city;
                        this.voucherParams.use = this.voucher.use;
                        this.voucherParams.personal = this.voucher.personal;
                        this.voucherParams.service = this.voucher.service;
                        this.voucherParams.localIncomeUnitPrice = this.voucher.local_income_unit_price;
                        this.voucherParams.localIncomePersonal = this.voucher.local_income_personal;
                        this.voucherParams.localIncome = this.voucher.local_income;
                        this.voucherParams.localPaymentUnitPrice = this.voucher.local_payment_unit_price;
                        this.voucherParams.localPaymentPersonal = this.voucher.local_payment_personal;
                        this.voucherParams.localPayment = this.voucher.local_payment;
                        this.voucherParams.localUnpaidUnitPrice = this.voucher.local_unpaid_unit_price;
                        this.voucherParams.localUnpaidPersonal = this.voucher.local_unpaid_personal;
                        this.voucherParams.localUnpaid = this.voucher.local_unpaid;
                        this.voucherParams.income = this.voucher.income;
                        this.voucherParams.unitPrice = this.voucher.unit_price;
                        this.voucherParams.totalAmount = this.voucher.total_amount;
                        this.voucherParams.currencyId = this.voucher.currency_id;
                        this.voucherParams.cashInOutType = this.voucher.cash_in_out_type;
                        this.voucherParams.taxRate = this.voucher.tax_rate;
                        this.voucherParams.taxExempt = this.voucher.tax_exempt;
                        this.voucherParams.personInCharge = this.voucher.person_in_charge;
                        this.voucherParams.note = this.voucher.note;
                        this.voucherParams.exchangeType = this.voucher.exchange_type;
                        this.voucherParams.amountBeforeExchange = this.voucher.amount_before_exchange;
                        this.voucherParams.amountAfterExchange = this.voucher.amount_after_exchange;
                        this.voucherParams.currencyBeforeExchangeId = this.voucher.currency_before_exchange_id;
                        this.voucherParams.currencyAfterExchangeId = this.voucher.currency_after_exchange_id;
                        this.voucherParams.totalIncome = this.voucher.total_income;
                        this.voucherParams.totalExpenditure = this.voucher.total_expenditure;
                        this.voucherParams.totalBalance = this.voucher.total_balance;
                        this.voucherParams.targetFlag = this.voucher.target_flag;
                        this.voucherParams.billedFlag = this.voucher.billed_flag;
                        this.voucherParams.is_slip = this.voucher.is_slip;
                        this.voucherParams.postsend_flag = this.voucher.postsend_flag;
                        this.voucherParams.status = this.voucher.status;
                        this.voucherParams.currencyDisplayName = this.voucher.currency_display_name;
                        this.voucherParams.voucherName = this.voucher.voucher_name;

                        // Other taxrate
                        if (this.voucher.currency_id == Constants.JPY.id && this.voucher.tax_rate == Constants.VoucherTaxRate.Other.id && this.voucher.other_tax) {
                            let voucherOtherTax = [];
                            this.voucher.other_tax.forEach(function (item) {
                                let newItem = {};
                                newItem.id = item.id;
                                newItem.taxRate = item.tax_rate;
                                newItem.description = item.description;
                                newItem.price = item.price;
                                voucherOtherTax.push(newItem);
                            });
                            this.voucherParams.otherRate = voucherOtherTax;
                        } else {
                            this.voucherParams.otherRate = [];
                        }

                        return () => import(`./Add/Temp_` + templateId + `.vue`);
                    }
                }
            },
        },
    },
    created () {
        if (Utils.isReadOnly()) {
            this.$emit("enableButton");
        } else {
            this.$emit("enableButton", this.$t("button.ok"));
        }
    },
    beforeMount () {
        this.voucherId = this.$route.query.voucherId;
        this.screenType = this.$route.query.screenType;
        this.getVoucherDetails();
    },
    methods: {
        getVoucherDetails () {
            VoucherService.getVoucherDetails(this.voucherId).then(response => {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (response.status != 200) {
                    let errorCode = Utils.getErrorCode(response);
                    if (errorCode) {
                        this.setErrorMessage(
                            this.$root.$t("error.error_code_" + errorCode)
                        );
                    }
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        this.voucher = response.data;
                        this.setErrorMessage("");
                    } else {
                        this.voucher = [];
                    }
                    if ((this.screenType == Constants.LocalIncomeScreenType && this.voucher.type == Constants.VoucherInOutType.Out.id) ||
                    (this.voucher.voucher_type_id == Constants.VoucherType.local_expense_voucher_receipt.id && (this.voucher.service == Constants.VoucherService.Optional.id ||
                    this.voucher.service == Constants.VoucherService.Agreement.id || this.voucher.service == Constants.VoucherService.Gifts.id ) && this.voucher.type == Constants.VoucherInOutType.Out.id)) {
                        this.voucher.total_amount = this.voucher.total_amount * -1;
                        this.voucher.income = this.voucher.income * -1;
                    }
                }
            });
        },
        setErrorMessage (msg) {
            this.errorMessage = msg;
        },

        voucherSuccess (id) {
            // Back to previous page (detail page)
            StorageService.saveCurrencyId(this.voucherParams.currencyId + "");
            this.$router.go(-1);
            // if (!Utils.isEmptyStr(id)) {
            //     this.$router.replace({
            //         path: "/voucher/detail",
            //         query: { voucherId: id, screenType: this.screenType },
            //     });
            //     // this.$router.push({path: '/voucher/detail', query: {voucherId: id}});
            // } else {
            //     this.$router.replace({
            //         path: "/voucher/list",
            //     });
            // }
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Voucher/Edit.vue